import * as React from "react";

import { reportAppRenderError } from "@/app/reportAppRenderError";

type ErrorBoundaryFallbackProps = {
    resetError: () => void;
};

type Props = {
    children: React.ReactNode;
    fallbackUI: (props: ErrorBoundaryFallbackProps) => React.ReactNode;
};

type State = {
    has_error: boolean;
};

/** Catches React render errors and shows a fallback UI with retry. */
export default class AppErrorBoundary extends React.Component<Props, State> {
    state: State = { has_error: false };

    static getDerivedStateFromError(): State {
        return { has_error: true };
    }

    componentDidCatch(error: Error, error_info: React.ErrorInfo): void {
        console.error("App error boundary caught:", error, error_info);
        reportAppRenderError(error, error_info);
    }

    resetError = (): void => {
        this.setState({ has_error: false });
    };

    render(): React.ReactNode {
        if (this.state.has_error) {
            return this.props.fallbackUI({ resetError: this.resetError });
        }
        return this.props.children;
    }
}
